module.exports = __webpack_public_path__ + "img/scene1@2x.c3594ddc.png";